import {config, sessionUser} from "../config";
import http from "./httpService";
import { IDENTITY_SERVER, HIEBUS_CONFIG } from "../auth/authConfig";
import {getIdentity} from "../components/common/commonFuncs";

////////////////////////////////////////////////////////////////
const prefix = "/api/v2/user/";

const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////
export function getRoles() {
  return http.get(apiEndpoint + prefix + "getRoles", { params: { Activity_By: getIdentity() } });
}

export function getUsers() {
  return http.get(apiEndpoint + prefix + "getUsers", { params: { Activity_By: getIdentity() } });
}

export function getUserByUsername(username) {
  return http.get(apiEndpoint + prefix + "getUserByUsername?Username=" + username, { params: { Activity_By: getIdentity() } });
}

export function getUserPermissionsByUsername(username) {
  return http.get(apiEndpoint + prefix + "getUserPermissionsByUsername?Username=" + username, { params: { Activity_By: getIdentity() } });
}

export function saveUser(user) {
  return http.post(apiEndpoint + prefix + "saveUser", {
    User_ID: user.User_ID,
    First_Name: user.First_Name,
    Last_Name: user.Last_Name,
    Username: user.Username,
    Email: user.Email,
    Role_List: user.Role_List.map(role => role.value),
    Activity_By: getIdentity()
  });
}

export function removeUser(UID) {
  return http.post(apiEndpoint + prefix + "removeUser", {
    User_ID: UID,
    Activity_By: getIdentity()
  });
}

export function getUserInfo() {
  return http.get(apiEndpoint + prefix + "getUserInfo", {
    params: {
      Username: getIdentity(),
      Activity_By: getIdentity()
    },
  });
}

// export function logActivity(page, action, otherInfo = null) {
//   return http.post(apiEndpoint + prefix + "logActivity", {
//     UserName: getIdentity(),
//     Email: JSON.parse(sessionStorage.getItem(sessionUser)).Email,
//     Page_Visited: page,
//     Page_Action: action,
//     Browser: navigator.userAgent,
//     Other_Info: otherInfo,
//   });
// }

export function getUserInfoViaToken() {
  //console.log('hey in identity', HIEBUS_CONFIG.authorizationUrl.includes('aspirecqi'))
  return (HIEBUS_CONFIG.authorizationUrl.includes('aspirecqi')) ? http.post(IDENTITY_SERVER + "/userinfo") : http.post(HIEBUS_CONFIG.user_info);
};

export function entraLoginUrl() {
  return apiEndpoint + prefix + "entraLogin";
}